import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { CommunicationAgreement } from "models";

const component = "AgreementsDashboard";

export const AgreementsDashboardQueryKeys = {
  list: backendQueryKey<CommunicationAgreement[]>({ baseUrl: ENV.appointmentBaseURL, endpoint: "/check_in/agreement/list", component })
};
